import app from 'flarum/forum/app';
export default function loadSpaceFeed(slug) {
  // slug кодируется отдельно и никогда не добавляется в query как готовая строка: это сохраняет
  // корректный маршрут для кириллических и специальных значений после будущего расширения тегов.
  return app.request({
    method: 'GET',
    url: `${app.forum.attribute('apiUrl')}/devconnect/portal/spaces/${encodeURIComponent(slug)}`
  });
}
flarum.reg.add('devconnect-portal', 'forum/service/spaceFeedApi', loadSpaceFeed);